import { combineReducers, configureStore } from '@reduxjs/toolkit';
import authReducer from './auth/authSlice';
import { errorHandler } from '@/utils/errorHandler';
import {
  adminApi,
  bookingApi,
  clientApi,
  mediaPlanApi,
  userApi,
  channelApi,
  rateCardApi,
  campaignApi,
  eu6CalculatorApi,
  calculatorPackagesApi,
  forecastingApi,
  pandaDocApi,
  ioTemplateApi
} from '@/api';
import { pdfApi } from '@/api/pdf';
import { apiMiddleware } from '@/api/registry';

const rootReducer = combineReducers({
  auth: authReducer,
  [adminApi.reducerPath]: adminApi.reducer,
  [bookingApi.reducerPath]: bookingApi.reducer,
  [mediaPlanApi.reducerPath]: mediaPlanApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [clientApi.reducerPath]: clientApi.reducer,
  [channelApi.reducerPath]: channelApi.reducer,
  [rateCardApi.reducerPath]: rateCardApi.reducer,
  [campaignApi.reducerPath]: campaignApi.reducer,
  [pdfApi.reducerPath]: pdfApi.reducer,
  [eu6CalculatorApi.reducerPath]: eu6CalculatorApi.reducer,
  [calculatorPackagesApi.reducerPath]: calculatorPackagesApi.reducer,
  [forecastingApi.reducerPath]: forecastingApi.reducer,
  [pandaDocApi.reducerPath]: pandaDocApi.reducer,
  [ioTemplateApi.reducerPath]: ioTemplateApi.reducer
});

export const setupStore = () =>
  configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(errorHandler, ...apiMiddleware)
  });

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
